export const base64GrayImage =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM89x8AAqEBz+RdzIIAAAAASUVORK5CYII=';
